import {connect} from 'react-redux';

import {getIndices} from '../../../../general/selectors';

import Number from './Number';

const Numbers = ({indices}) => (
    <div className="numbers">
        {indices.map(index => <Number {...index} />)}
    </div>
);

const mapStateToProps = state => ({
    indices: getIndices(state),
});

export default connect(mapStateToProps)(Numbers);
